import React from 'react';
import { Trans } from 'react-i18next';
import classnames from 'classnames';
import { formatPrice } from '../../BookitoStepperBookingRequestForm/ParticularsInfoSelection';
import { LocalizedEventData } from '@carlito/bookito-client';
import { BookitoBookingFormValues } from '../shared/types';

export type Props = {
  eventPriceVariants: LocalizedEventData['priceVariants'];
  priceVariants: BookitoBookingFormValues['priceVariants'];
  onPriceVariantsChange: (priceVariants: BookitoBookingFormValues['priceVariants']) => void;
};

export function BookingPriceVariants({
  priceVariants,
  onPriceVariantsChange,
  eventPriceVariants,
}: Props) {
  if (!eventPriceVariants) return null;
  return (
    <div className="mt-6">
      <h2 className="text-md font-bold">
        <Trans>extras</Trans>
      </h2>
      <div className="space-y-4 mt-4">
        {eventPriceVariants.map((priceVariant) => {
          const isSelected = priceVariants?.includes(priceVariant.id);

          function onToggle() {
            if (isSelected) {
              onPriceVariantsChange(
                priceVariants?.filter((priceVariantId) => priceVariantId !== priceVariant.id)
              );
            } else {
              onPriceVariantsChange([...(priceVariants ?? []), priceVariant.id]);
            }
          }

          return (
            <div key={priceVariant.id} className="flex items-center justify-between">
              <button
                className={classnames(
                  'border-2 rounded-full border-primary-default py-1 px-2 text-sm',
                  {
                    'bg-primary-default text-primary-contrast': isSelected,
                  }
                )}
                type="button"
                onClick={onToggle}
              >
                {priceVariant.description}
              </button>
              {priceVariant.priceVariation.amount !== null &&
                priceVariant.priceVariation.amount > 0 && (
                  <span className="text-gray-400">
                    {formatPrice(priceVariant.priceVariation.amount)}
                  </span>
                )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default BookingPriceVariants;
